import LivenessStatusBar from './liveness-status-bar';

export default LivenessStatusBar;